// extracted by mini-css-extract-plugin
export default {"topo":"Especialidades_topo__apLzv","lista":"Especialidades_lista__4vAlQ"};